import React, { useState } from 'react'

import GuaranteedAmount from './guaranteed-amount'
import { GuaranteedAmountProvider } from './guaranteed-amount-context'

const GuaranteedAmountPage: React.FC = () => {
  const [salaries, setSalaries] = useState([])

  return (
    <GuaranteedAmountProvider value={{ salaries, setSalaries }}>
      <GuaranteedAmount />
    </GuaranteedAmountProvider>
  )
}

export default GuaranteedAmountPage
